var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "single-contact-import" },
    [
      _c("h3", [_vm._v("Kişi Ekle")]),
      _vm._v(" "),
      !_vm.skipPlatformSelection
        ? _c("div", { staticClass: "platform-selection" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("Platform")]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.selectedPlatform,
                      callback: function ($$v) {
                        _vm.selectedPlatform = $$v
                      },
                      expression: "selectedPlatform",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "supsis" } }, [
                      _vm._v("Supsis"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "mail" } }, [
                      _vm._v("Mail"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "whatsapp" } }, [
                      _vm._v("Whatsapp"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.selectedPlatform === "whatsapp" &&
            _vm.whatsappChannels.length > 0
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Kanal")]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { mode: "multiple" },
                        model: {
                          value: _vm.selectedChannels,
                          callback: function ($$v) {
                            _vm.selectedChannels = $$v
                          },
                          expression: "selectedChannels",
                        },
                      },
                      _vm._l(_vm.whatsappChannels, function (channel) {
                        return _c(
                          "a-select-option",
                          { key: channel._id, attrs: { value: channel._id } },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(channel.name) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-form" },
        [
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("a-input", {
                  attrs: { placeholder: "Ad Soyad giriniz" },
                  model: {
                    value: _vm.contact.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.contact, "name", $$v)
                    },
                    expression: "contact.name",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [_vm._v("E-posta")]),
                _vm._v(" "),
                _c("a-input", {
                  attrs: { placeholder: "E-posta giriniz" },
                  model: {
                    value: _vm.contact.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.contact, "email", $$v)
                    },
                    expression: "contact.email",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Telefon")]),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: "Telefon giriniz" },
                model: {
                  value: _vm.contact.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.contact, "phone", $$v)
                  },
                  expression: "contact.phone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.contactProperties.length > 0 ? _c("a-divider") : _vm._e(),
          _vm._v(" "),
          _vm.contactProperties.length > 0
            ? [
                _c("h4", [_vm._v("Özel Alanlar")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row-fields" },
                  _vm._l(_vm.contactProperties, function (property) {
                    return _c(
                      "div",
                      {
                        key: property._id,
                        staticClass: "form-group custom-field",
                      },
                      [
                        _c("label", [_vm._v(_vm._s(property.label))]),
                        _vm._v(" "),
                        property.type === "text" || property.type === "string"
                          ? _c("a-input", {
                              attrs: { placeholder: "Değer giriniz" },
                              model: {
                                value: _vm.customFields[property.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.customFields, property.name, $$v)
                                },
                                expression: "customFields[property.name]",
                              },
                            })
                          : property.type === "date"
                          ? _c("a-date-picker", {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.customFields[property.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.customFields, property.name, $$v)
                                },
                                expression: "customFields[property.name]",
                              },
                            })
                          : property.type === "select"
                          ? _c(
                              "a-select",
                              {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.customFields[property.name],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customFields,
                                      property.name,
                                      $$v
                                    )
                                  },
                                  expression: "customFields[property.name]",
                                },
                              },
                              _vm._l(property.options, function (option) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: option.value,
                                    attrs: { value: option.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(option.label) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _c("a-input", {
                              attrs: { placeholder: "Değer giriniz" },
                              model: {
                                value: _vm.customFields[property.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.customFields, property.name, $$v)
                                },
                                expression: "customFields[property.name]",
                              },
                            }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-actions" },
        [
          _c("a-button", { on: { click: _vm.onCancelled } }, [_vm._v("İptal")]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.loading,
                disabled: !_vm.isFormValid,
              },
              on: { click: _vm.addContact },
            },
            [_vm._v("\n            Kişi Ekle\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Ad Soyad "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }